import { ErrorIcon, SuccessIcon } from 'app/assets/images/icons';
import { _t } from 'app/utils/i18n';
import React, { FunctionComponent } from 'react';

import styles from './CriteriaValidation.module.scss';

interface Props {
  value: any;
}

const CriteriaValidation: FunctionComponent<Props> = ({ value }) => {
  const errorMessage: string[] = [];
  const errorsList = [
    'at_least_8_characters',
    'upperCase',
    'lowerCase',
    'number',
    'special_character',
  ];
  if (!value?.match(/.{8,}/)) errorMessage.push(errorsList[0]);

  if (!value?.match(/(.*[A-Z])/)) errorMessage.push(errorsList[1]);

  if (!value?.match(/(.*[a-z])/)) errorMessage.push(errorsList[2]);

  if (!value?.match(/\d+/)) errorMessage.push(errorsList[3]);

  if (!value?.match(/(.*[-._!"`'#%&,:;<>=@{}~\$\(\)\*\+\/\\\?\[\]\^\|])/))
    errorMessage.push(errorsList[4]);

  if (!value) return <></>;
  return (
    <div className={styles.CriteriaValidation}>
      <h5>{_t('users:your_password_must')} :</h5>
      <ul className={styles.List}>
        {errorsList.map((error) => {
          const isError = errorMessage.includes(error);
          return (
            <li key={error} className={isError ? styles.Error : ''}>
              <span>{isError ? <ErrorIcon /> : <SuccessIcon />}</span>
              <span>{_t(`users:${error}`)}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default CriteriaValidation;
